export const mortgageConditions = {
    heading: 'mortgage-conditions-page-heading',
    paragraph1: 'mortgage-conditions-page-paragraph-1',
    paragraph2: 'mortgage-conditions-page-paragraph-2',
    backButton: 'mortgage-conditions-page-back-button',
}